<template>
  <div id="financeTop">
    <div class="title">
      <img src="../../assets/image/icon_tj@2x.png" style="width:34px" alt />
      <h3>工具</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="clientActive" @tab-click="handleClick">
        <!-- 1报销 -->
        <el-tab-pane label="水印相机" name="1">
          <!-- 按钮行 -->
          <div class="btnRow">
            <div class="left" style="width:70%">
              <el-input v-model="searchInfo1" placeholder="水印查询"></el-input>
              <one-selected @my-one-change="handleSearchPeopleChange"></one-selected>
            </div>
            <div class="right">
              <el-button @click="handleSearch1" class="search">查询</el-button>
            </div>
          </div>
          <!-- 表格行 -->
          <div class="financeTable">
            <div class="table">
              <div class="table_head">
                <div class="headerItem" style="width:20%">申请人</div>
                <div class="headerItem" style="width:25%;text-align:center">地点</div>
                <div class="headerItem" style="width:20%;text-align:center">时间</div>
                <div class="headerItem" style="width:13%;text-align:center">状态</div>
                <div class="headerItem" style="width:23%;text-align:center">操作</div>
              </div>
              <ul class="table__body" v-if="tableData1.length>0">
                <li class="tableBodyItem" v-for="item in tableData1" :key="item.id">
                  <div class="bodyItem" style="width:20%">
                    <h3 class="knowledgeTitle overflowDoit">{{item.member.nickname}}</h3>
                  </div>
                  <div class="bodyItem" style="width:25%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.address}}</p>
                  </div>
                  <div class="bodyItem" style="width:20%;padding-right:0;text-align:center;">
                    <p style="text-align:center;">{{item.show_time}}</p>
                  </div>

                  <div class="bodyItem" style="width:13%;padding-right:0;text-align:center;">
                    <!-- <p v-if="item.is_draft=='1'">草稿</p>
                    <p v-else>待审核</p>-->
                    <p class="overflowDoit" style="color:#FF3333" v-if="item.is_draft==1">{{'草稿'}}</p>
                    <p class="overflowDoit" style="color:#FF3333" v-if="item.status==1">{{'已删除'}}</p>
                    <p
                      class="overflowDoit"
                      style="color:#128bf1;"
                      v-if="item.status!='1' && item.is_draft!='1'"
                    >{{'已提交'}}</p>
                  </div>
                  <div class="bodyItem" style="width:23%;padding-right:0;text-align:center;">
                    <div class="tableBtnRow">
                      <el-button @click="handleCheckReimbursement(item.id)" class="check">查看明细</el-button>
                      <el-button
                        :disabled="isAdmin1==0 ? false : true"
                        @click="handleRemoveReimbursement(item)"
                        class="remove"
                      >删除</el-button>
                    </div>
                  </div>
                </li>
              </ul>
              <div v-else class="emptyImg table__body">
                <p style="color:#909399;text-align:center;margin-top:10vh">暂无数据</p>
              </div>
            </div>
          </div>
          <!-- 页码行 -->
          <div class="pageRow">
            <el-pagination
              v-if="tableData1.length>0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20, 30]"
              :page-size="pageSize"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="Total"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 弹窗--报销 -->
    <!-- :class="showForm==='showFormAdd' || showForm==='showFormHandle'? 'addClientDia' : 'addOtherDia'" -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      :class="'addClientDia' "
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">水印详情</span>
      </div>
      <!-- <div class="shenpiBtn">
        <el-button
          style="background-color: #F4A029;"
          v-if="showForm==='showFormHandle'"
          @click="dialogVisible = false"
        >驳回</el-button>
        <el-button type="primary" v-if="showForm==='showFormHandle'" @click="handleAddSubmit">通过</el-button>
      </div>-->

      <div class="diaContainer yauto">
        <!-- 报销审批表单 -->
        <el-form ref="form" :model="addUserForm" label-position="left" label-width="110px">
          <div class="diaForm_box diaEditFormBox">
            <!-- <div class="ShowFormBtn">
              <el-button
                v-if="addReimbursementForm.withdraw_status=='1'"
                @click="handleFinnaceWithDraw('reimbursement',addReimbursementForm.id)"
                class="withdrap"
                style="background-color:rgb(255, 26, 26);"
              >撤回</el-button>
              <el-button
                v-if="addReimbursementForm.approval_status=='1'"
                @click="handleFinnaceApproval('-1','reimbursement',addReimbursementForm.id)"
                class="search"
              >驳回</el-button>
              <el-button
                v-if="addReimbursementForm.approval_status=='1'"
                @click="handleFinnaceApproval('1','reimbursement',addReimbursementForm.id)"
                class="creat"
                style="background-color:#40A0F2;"
              >通过</el-button>
            </div>
            <el-form-item label="驳回节点" v-if="addReimbursementForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择">
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addReimbursementForm.stage_select"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addReimbursementForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>-->
            <div class="diaFormTitle">水印工具</div>
            <div style="box-sizing:border-box;padding:0 10%">
              <!-- 申请人 -->
              <el-form-item
                label="申请人"
                style="margin-bottom:0px;"
                v-if="addReimbursementForm.member"
              >
                <span
                  v-if="addReimbursementForm.member"
                  style="color:#666;font-size:16px"
                >{{addReimbursementForm.member.nickname}}</span>
              </el-form-item>
              <!-- 地点 -->
              <el-form-item label="地点" style="margin-bottom:0px;">
                <span style="color:#666;font-size:16px">{{addReimbursementForm.address}}</span>
              </el-form-item>
              <!-- 时间 -->
              <el-form-item label="时间" style="margin-bottom:0px;">
                <span style="color:#666;font-size:16px">{{addReimbursementForm.show_time}}</span>
              </el-form-item>
              <!-- 备注 -->
              <el-form-item label="备注" style="margin-bottom:20px">
                <el-input
                  type="textarea"
                  class="onlyShowText"
                  disabled
                  autosize
                  v-model="addReimbursementForm.remark"
                ></el-input>
                <!-- <span>{{addReimbursementForm.remark}}</span> -->
              </el-form-item>
              <!-- 附件 -->
              <el-form-item label="附件" style="margin-bottom:20px">
                <ul class="upLoadImgList">
                  <li
                    @click="handleCheckOutImgItem(item,index)"
                    class="upLoadImgBox noClose"
                    v-for="(item,index) in imgList"
                    :key="item"
                  >
                    <div class="closeBox">
                      <img style="width:100px; height:85px" :src="item" />
                    </div>
                  </li>
                </ul>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        报销新增按钮
        <el-button
          style="background-color: #ccc;"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft!='1'"
          @click="handleAddReimbursementSubmit('1')"
        >保存草稿</el-button>
        <el-button
          type="primary"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft!='1'"
          @click="handleAddReimbursementSubmit('0')"
        >提 交</el-button>
        报销编辑按钮
        <el-button
          style="background-color: #ccc;"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft=='1' && !draftDisable1"
          @click="handleEditReimbursementSubmit('1')"
        >保存草稿</el-button>
        <el-button
          type="primary"
          v-if="showForm==='showFormAdd' && addReimbursementForm.is_draft=='1' && !draftDisable1"
          @click="handleEditReimbursementSubmit('0')"
        >提 交</el-button>
        报销重新提交按钮
        <el-button
          style="background-color: #ccc;"
          v-if="showForm==='showFormHandle' && addReimbursementForm.is_edit=='1'"
          @click="dialogVisible=false"
        >取 消</el-button>
        <el-button
          type="primary"
          v-if="showForm==='showFormHandle' && addReimbursementForm.is_edit=='1'"
          @click="handleEditReimbursementSubmit('0')"
        >提 交</el-button>
      </div>-->
    </el-dialog>

    <!-- 附件详情弹窗 -->
    <el-dialog
      :visible.sync="imgDia"
      width="80%"
      :before-close="imghandleClose"
      class="addClientDia"
      @close="imghandleClosed"
      v-dialogDrag
    >
      <div style="height: 70vh;width: 100%;background-color: #333">
        <!-- <viewer
          class="viewer"
          ref="viewer"
          :options="optionsViewer"
          :images="imgList"
          style="width: 100%;height: 100%;background-size: contain;background-repeat: no-repeat; background-position: center;background-color: #3e5c9a;"
        >
          <img
            v-for="(img, index) in imgList"
            :src="img"
            :key="index"
            style="opacity: 0.2;display: none;width: 400px;height: 300px;background-color: #42b983;"
          />
        </viewer>-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import echarts from 'echarts'
import Draggable from 'vuedraggable'
import OneSelected from '../../components/OneSelected'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      inline: true,
      isAdmin1: '',
      isAdmin2: '',
      isAdmin3: '',
      isAdmin4: '',
      isAdmin5: '',
      isAdmin6: '',
      // 弹窗
      dialogVisible: false,
      imgDia: false,
      imgList: [],
      checkOutImgIndex: '',
      IsCloseShow: [],
      // 弹窗
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      searchInfo1: '',
      searchDate: '',
      searchDate1: '',
      searchDate2: '',
      editName: '',
      editId: '',
      contactsSum: 1,
      k_code: '',
      contactsList: [
        {
          name: '',
          phone: '',
          charege: '',
          wx: '',
        },
      ],
      activities: [
        {
          content: '活动按期开始',
          timestamp: '2018-04-15',
        },
        {
          content: '通过审核',
          timestamp: '2018-04-13',
        },
        {
          content: '创建成功',
          timestamp: '2018-04-11',
        },
      ],
      knowledgeList: [],

      contactsEditList: [],
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      SelectNum: 0,
      showForm: '',
      clientActive: '1',
      searchInfo1: '',
      searchInfo2: '',
      searchInfo3: '',
      searchInfo4: '',
      searchDateInfo1: '',
      searchDateInfo2: '',
      searchDateInfo3: '',
      searchDateInfo4: '',
      currentPage: 1,
      Total: 0,
      pageSize: 10,
      dialogVisible: false,
      searchInfo: {
        startDate: '',
        endDate: '',
        userName: '',
        projectType: '全部',
        clientStatus: '全部',
      },
      editUserForm: {},
      // 新增成员
      addUserForm: {
        customer_name: '',
        project_type: [],
        type: '0',
        is_company: '0',
        source: '',
        describe: '',
        remark: '',
        contacts: '',
      },
      projectTypeList: [],
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.searchDate2) {
            return (
              time.getTime() > new Date(this.searchDate2).getTime() ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.searchDate1) {
            return (
              time.getTime() <
                new Date(this.searchDate1).getTime() - 86400000 ||
              time.getTime() > Date.now() - 8.64e6
            )
          } else {
            return time.getTime() > Date.now() - 8.64e6
          }
        },
      },
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      tableData5: [],
      tableData6: [],
      tiemID: null,
      timeDou: 100,
      financeIndexData: {},
      // 新增报销
      addReimbursementForm: {
        project_list: [],
        type: '1',
        title: '',
        destination: '',
        date: '',
        driving_range: '',
        driving_mileage: 0.0,
        driving_expenses: '',
        hotel: 0.0,
        traffic: 0.0,
        food_bill: 0.0,
        other: 0.0,
        total: '',
        remark: '',
        annex: '',
        project_id: [],
      },
      // 新增项目结算申请
      addSettlementForm: {
        project_list: [],
        total: '',
        remark: '',
        annex: '',
        project_id: [],
      },
      // 新增项目专家费申请
      addExpertForm: {
        project_list: [],
        total: '',
        remark: '',
        annex: '',
        project_id: [],
      },
      // 新增到账记录
      addArrivalForm: {
        project_list: [],
        total: '',
        date: '',
        remark: '',
        annex: '',
        project_id: [],
      },
      // 6.新增业务结算申请
      addBusinessForm: {
        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: '',
        project_id: [],
      },
      // 7.新增合同登记
      addContractForm: {
        ontract_no: '',
        business_name: '',
        project_type: '',
        manager: '',
        paid: '',
        date_sign: '',

        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: '',
        project_id: [],
      },
      selectProjectNum: '',
      projectList: [],
      approvalRemark: '',
      imgSize: '100%',
      searchUserId: '',
      searchType: '',
      draftDisable1: false,
      draftDisable2: false,
      draftDisable3: false,
      draftDisable4: false,
      draftDisable5: false,
      draftDisable6: false,
    }
  },
  components: {
    Draggable,
    OneSelected,
  },
  methods: {
    async handleFinnaceWithDraw(stage_code, finance_id) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisibleFinnace = false
      if (stage_code == 'reimbursement') {
        this.getReimbursementList()
      }
      if (stage_code == 'settlement') {
        this.getSettlementList()
      }
      if (stage_code == 'expert') {
        this.getExpertList()
      }
      if (stage_code == 'arrival') {
        this.getArrivalList()
      }
      if (stage_code == 'business') {
        this.getBusinessList()
      }
      if (stage_code == 'contract') {
        this.getContractList()
      }
      if (stage_code == 'reportb') {
        this.getContractList()
      }
      this.dialogVisible = false
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.searchUserId = data
    },
    handleSizeImgChange(val) {
      if (val == 'add') {
        // console.log(parseInt(this.imgSize.split('%')[0]))
        // parseInt(this.imgSize.split('%')[0]) += 20
        const a = parseInt(this.imgSize.split('%')[0]) + 20
        this.imgSize = a + '%'
      } else if (val == 'down') {
        const a = parseInt(this.imgSize.split('%')[0]) - 20
        this.imgSize = a + '%'
      }
      console.log('this.imgSize', this.imgSize)
    },
    handleSearch1() {
      if (this.searchDate1 == null || this.searchDate1 == 'null') {
        this.searchDate1 = ''
      }
      if (this.searchDate2 == null || this.searchDate2 == 'null') {
        this.searchDate2 = ''
      }
      this.currentPage = 1
      this.getReimbursementList()
    },

    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisibleFinnace = false
      if (stage_code == 'reimbursement') {
        this.getReimbursementList()
      }
      if (stage_code == 'settlement') {
        this.getSettlementList()
      }
      if (stage_code == 'expert') {
        this.getExpertList()
      }
      if (stage_code == 'arrival') {
        this.getArrivalList()
      }
      if (stage_code == 'business') {
        this.getBusinessList()
      }
      if (stage_code == 'contract') {
        this.getContractList()
      }
      this.dialogVisible = false
    },
    handleListChange(event) {
      this.imgList = event
      console.log(this.fileList)
    },

    // *编辑报销提交
    async handleEditReimbursementSubmit(val) {
      if (this.addReimbursementForm.date == null) {
        this.addReimbursementForm.date = ''
      }

      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addReimbursementForm.id)

        param.append('type', this.addReimbursementForm.type)
        param.append('title', this.addReimbursementForm.title)
        param.append('destination', this.addReimbursementForm.destination)
        param.append('date', this.addReimbursementForm.date)
        param.append('driving_range', this.addReimbursementForm.driving_range)
        param.append(
          'driving_mileage',
          this.addReimbursementForm.driving_mileage
        )
        param.append('driving_expenses', this.driveMoney)
        param.append('hotel', this.addReimbursementForm.hotel)
        param.append('traffic', this.addReimbursementForm.traffic)
        param.append('food_bill', this.addReimbursementForm.food_bill)
        param.append('other', this.addReimbursementForm.other)
        param.append('total', this.sumMoney)
        param.append('remark', this.addReimbursementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        param.append(
          'project_id',
          this.addReimbursementForm.project_id.join(',')
        )

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/reimbursement_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)

        this.getReimbursementList()
        this.dialogVisible = false
      }, this.timeDou)
    },
    // *查看报销详情
    async handleCheckReimbursement(id) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      param.append('finance_id', id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Tool/car_detail',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.addReimbursementForm = res.datas.info
      // 处理项目
      // 处理图片
      if (this.addReimbursementForm.annex) {
        this.imgList = this.addReimbursementForm.annex
      }
      console.log('报销详情', this.addReimbursementForm)
      // 判断草稿禁用
      this.dialogVisible = true
    },
    // *报销点击提交
    async handleAddReimbursementSubmit(val) {
      if (this.addReimbursementForm.date == null) {
        this.addReimbursementForm.date = ''
      }
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('type', this.addReimbursementForm.type)
        param.append('title', this.addReimbursementForm.title)
        param.append('destination', this.addReimbursementForm.destination)
        param.append('date', this.addReimbursementForm.date)
        param.append('driving_range', this.addReimbursementForm.driving_range)
        param.append(
          'driving_mileage',
          this.addReimbursementForm.driving_mileage
        )
        param.append('driving_expenses', this.driveMoney)
        param.append('hotel', this.addReimbursementForm.hotel)
        param.append('traffic', this.addReimbursementForm.traffic)
        param.append('food_bill', this.addReimbursementForm.food_bill)
        param.append('other', this.addReimbursementForm.other)
        param.append('total', this.sumMoney)
        param.append('remark', this.addReimbursementForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        param.append(
          'project_id',
          this.addReimbursementForm.project_id.join(',')
        )

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/reimbursement_add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)

        this.dialogVisible = false
        this.getReimbursementList()
      }, this.timeDou)
    },
    // *报销删除
    async handleRemoveReimbursement(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('finance_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Tool/car_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getReimbursementList()
      }
    },
    // *获取报销列表
    async getReimbursementList() {
      // Finance/reimbursement
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('search', this.searchInfo1)
      param.append('search_member_id', this.searchUserId)

      param.append('p', this.currentPage)
      param.append('p_count', this.pageSize)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Tool/car',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.tableData1 = res.datas.listInfo
      this.Total = parseInt(res.datas.count)
      // :disabled="isAdmin1==0 ? false : true"
      this.isAdmin1 = res.datas.admin_state

      console.log('报销列表', this.tableData1)
    },

    // *获取项目列表
    async getProjectList() {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectList = res.datas.listInfo
      console.log('项目列表(用于表单选项)', this.financeIndexData)
    },
    // 获取项目类型
    async getProjectTypeList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/project_type',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.projectTypeList = res.datas.listInfo
      console.log('项目类型列表', this.projectTypeList)
    },
    // 选择项目名称1
    handleProjectSelectChange1() {
      this.selectProjectNum = ''
      if (this.clientActive == 2) {
        this.projectList.forEach((item) => {
          this.addReimbursementForm.project_id.forEach((items) => {
            if (items == item.project_id) {
              this.selectProjectNum += item.project_code + ','
            }
          })
        })
      } else if (this.clientActive == 3) {
        this.projectList.forEach((item) => {
          this.addSettlementForm.project_id.forEach((items) => {
            if (items == item.project_id) {
              this.selectProjectNum += item.project_code + ','
            }
          })
        })
      } else if (this.clientActive == 4) {
        this.projectList.forEach((item) => {
          this.addExpertForm.project_id.forEach((items) => {
            if (items == item.project_id) {
              this.selectProjectNum += item.project_code + ','
            }
          })
        })
      } else if (this.clientActive == 5) {
        this.projectList.forEach((item) => {
          this.addArrivalForm.project_id.forEach((items) => {
            if (items == item.project_id) {
              this.selectProjectNum += item.project_code + ','
            }
          })
        })
      } else if (this.clientActive == 6) {
        this.projectList.forEach((item) => {
          this.addBusinessForm.project_id.forEach((items) => {
            if (items == item.project_id) {
              this.selectProjectNum += item.project_code + ','
            }
          })
        })
      } else if (this.clientActive == 7) {
        this.projectList.forEach((item) => {
          this.addContractForm.project_id.forEach((items) => {
            if (items == item.project_id) {
              this.selectProjectNum += item.project_code + ','
            }
          })
        })
      }
      this.selectProjectNum = this.selectProjectNum.substr(
        0,
        this.selectProjectNum.length - 1
      )
    },
    // 下载图片
    DownImg() {
      var a = document.createElement('a')
      a.download = this.imgList[this.checkOutImgIndex]
      // 设置图片地址
      a.href = this.imgList[this.checkOutImgIndex]
      a.click()
    },
    goTop() {
      this.checkOutImgIndex = parseInt(this.checkOutImgIndex) - 1
      console.log(this.checkOutImgIndex)
    },
    goBottom() {
      this.checkOutImgIndex = parseInt(this.checkOutImgIndex) + 1
      console.log(this.checkOutImgIndex)
    },
    handleCheckOutImgItem(val, index) {
      // const $viewer = this.$viewerApi({
      //   images: this.sourceImageURLs,
      // })
      // 或者你可以单独引入api然后执行它
      console.log('imgList', this.imgList)
      const $viewer = viewerApi({
        options: {
          toolbar: true,
          // url: 'data-source',
          initialViewIndex: index,
          tooltip: true,
          fullscreen: true,
          keyboard: true,
          zIndex: 9999,
        },
        images: this.imgList,
      })
      return
      this.checkOutImgIndex = this.imgList.findIndex((item) => item === val)
      if (this.checkOutImgIndex != -1) {
        this.imgDia = true
      }
    },

    // 上传图片(报销新增)
    async handleBefore(file) {
      let param = new FormData()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('file', file)
      const { data: res } = await this.$axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: '/api/User/uploadImg',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success('上传成功')
      console.log('企业logo', res.datas.img_url)
      this.imgList.push(res.datas.img_url)
    },
    // (报销新增)
    removeItem(val) {
      let delindex = this.imgList.findIndex((item) => item === val)
      this.imgList.splice(delindex, 1)
    },

    handleAddSubmit() {},

    // 7.点击新增合同登记
    addContractClick() {
      this.showForm = 'showFormContractAdd'
      this.dialogVisible = true
    },
    // 7.查看合同登记
    // handleCheckContract() {
    //   this.showForm = 'showFormContractHandle'
    //   this.dialogVisible = true
    // },
    // 6.点击新增业务结算申请
    addBusinessClick() {
      this.showForm = 'showFormBusinessAdd'
      this.dialogVisible = true
    },
    // 6.查看业务结算申请详情
    // handleCheckBusiness() {
    //   this.showForm = 'showFormBusinessHandle'
    //   this.dialogVisible = true
    // },
    // 点击新增报销按钮
    addProjectFinanceClick() {
      this.showForm = 'showFormAdd'
      this.dialogVisible = true
    },
    handleClick(tab, event) {
      this.searchInfo1 = ''
      this.searchDate1 = ''
      this.searchDate2 = ''
      this.searchType = ''
      this.pageSize = 10
      this.searchUserId = ''
      this.currentPage = 1
      console.log(tab, event)
      if (tab.name == '1') {
        this.getReimbursementList()
        let a = document.getElementsByClassName('el-tabs__active-bar')
        a[0].style.marginLeft = '50px'
      }
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.imgList = []
      this.selectProjectNum = ''
      this.approvalRemark = ''
      this.k_code = ''
      this.draftDisable1 = false
      // 清空报销相关
      this.addReimbursementForm = {
        type: '1',
        title: '',
        destination: '',
        date: '',
        driving_range: '',
        driving_mileage: 0.0,
        driving_expenses: '',
        hotel: 0.0,
        traffic: 0.0,
        food_bill: 0.0,
        other: 0.0,
        total: '',
        remark: '',
        annex: '',
        project_id: [],
      }
    },
    imghandleClose(done) {
      this.imgDia = false
    },
    imghandleClosed() {
      this.imgSize = '100%'
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
      if (this.clientActive == 1) {
        this.pageSize = val
        this.getReimbursementList()
      }
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      if (this.clientActive == 1) {
        this.getReimbursementList()
      }
    },
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.activeName = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
    this.getProjectList()
    this.getProjectTypeList()
    this.getReimbursementList()
  },
  mounted() {},
  computed: {
    // 总计
    sumMoney() {
      var dMoney = parseFloat(
        (this.addReimbursementForm.driving_mileage * 1.25).toFixed(2)
      )
      console.log('dMoney1', dMoney)
      return (
        dMoney +
        this.addReimbursementForm.hotel * 1.0 +
        this.addReimbursementForm.traffic * 1.0 +
        this.addReimbursementForm.food_bill * 1.0 +
        this.addReimbursementForm.other * 1.0
      ).toFixed(2)
    },
    // 开车费用
    driveMoney() {
      return (this.addReimbursementForm.driving_mileage * 1.25).toFixed(2)
    },
  },
}
</script>
<style lang="less" scoped>
#financeTop {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;

  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;

    // 引入项目财务样式
    .btnRow {
      width: 100%;
      display: flex;
      align-content: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .fffBorder {
        /deep/.el-input__inner {
          background-color: #fff !important;
          border: 1px solid #ebebeb !important;
        }
      }
      .left {
        width: 50%;
        display: flex;
        /deep/.el-input {
          width: 40%;
          margin-right: 10%;
          // (deep)
          .el-input__inner {
            padding-left: 25px;
            height: 45px;
            border-radius: 24px;
            font-size: 16px;
            border: none;
            background-color: #f4f5f6;
            color: #333;
            &::placeholder {
              color: #333;
            }

            &::-webkit-input-placeholder {
              /* WebKit browsers 适配谷歌 */
              color: #333;
            }

            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 适配火狐 */
              color: #333;
            }
          }
        }
      }
      .modifyLeft {
        /deep/.el-input {
          width: 45%;
          margin-right: 5%;
          // (deep)
          .el-input__inner {
            height: 45px;
            font-size: 16px;
            border-radius: 24px;
            width: 100%;
            background-color: #f4f5f6;
            border: none;
          }
        }
      }
      /deep/.el-button {
        font-size: 18px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 45px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
    }
    .totalNum {
      width: 100%;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 0 3px;
      margin-bottom: 20px;
      li {
        width: 16%;
        height: 120px;
        border-radius: 10px;
        box-shadow: 1px 3px 9px 0px rgba(3, 70, 126, 0.14);
        display: flex;
        flex-direction: column;
        align-items: center;
        .title {
          font-size: 20px;
          padding: 0;
          margin-top: 25px;
          margin-bottom: 10px;
        }
        .number {
          font-size: 24px;
        }
      }
    }
    .echartsRow {
      height: calc(100% - 68px - 120px - 20px - 20px);
      box-sizing: border-box;
      padding: 0 3px;
      display: flex;
      .leftEcharts {
        width: 49.1%;
        box-shadow: 1px 3px 9px 0px rgba(3, 70, 126, 0.14);
        margin-right: 1.8%;
        border-radius: 10px;
      }
      .rightEcarts {
        width: 49.1%;
        box-shadow: 1px 3px 9px 0px rgba(3, 70, 126, 0.14);
        border-radius: 10px;
      }
    }
    // 表格行

    .financeTable {
      width: 100%;
      height: calc(100% - 138px);
      .table {
        width: 100%;
        height: 100%;
        .table_head {
          box-sizing: border-box;
          padding: 0 40px;
          width: 100%;
          height: 60px;
          font-size: 18px;
          color: #fff;
          background-color: #40a0f2;
          display: flex;
          align-items: center;
        }
        .table__body {
          box-sizing: border-box;
          height: calc(100% - 60px);
          width: 100%;
          overflow-y: auto;
          padding: 0 2px;
          // li
          .tableBodyItem {
            cursor: pointer;
            box-sizing: border-box;
            padding: 13px 40px;
            border-bottom: 1px solid #ebebeb;
            width: 100%;
            height: 8vh;
            display: flex;
            .bodyItem {
              box-sizing: border-box;
              padding-right: 30px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              .knowledgeTitle {
                margin-bottom: 4px;
                font-size: 18px;
                font-weight: normal;
                color: #333333;
              }
              p {
                font-size: 14px;
                color: #666666;
              }
              .tableItemContent {
                width: 100%;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
              }
              .tableBtnRow {
                width: 100%;
                display: flex;
                justify-content: center;
                /deep/.el-button {
                  padding: 0 24px;
                  display: flex;
                  align-items: center;
                  font-weight: normal;
                  height: 32px;
                }
                /deep/.edit {
                  margin-right: 10px;
                  color: rgb(245, 95, 95);
                  border-color: rgb(245, 95, 95);
                }
                /deep/.check {
                  color: #10981d;
                  border-color: #66c16f;
                  margin-right: 10px;
                }
              }
              .overflowDoit {
                width: 100%;
                overflow: hidden; /*超出部分隐藏*/
                white-space: nowrap; /*不换行*/
                text-overflow: ellipsis; /*超出部分文字以...显示*/
              }
            }

            .headerLogo {
              width: 46px;
              height: 46px;
              border-radius: 50%;
              margin-left: 10px;
            }
          }
          .tableBodyItem:hover {
            box-shadow: 0px 0px 9px 0px rgba(3, 70, 126, 0.14);
            .knowledgeTitle {
              color: #128bf1;
            }
          }
        }
      }

      // 分页行
      .pageRow {
        height: 20px;
        box-sizing: border-box;
        margin-top: 10px;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: flex-end;
        /deep/.el-pagination .el-select .el-input .el-input__inner {
          font-size: 14px;
        }
        /deep/.el-pagination button,
        /deep/.el-pagination span:not([class*='suffix']) {
          font-size: 14px;
        }
      }
    }
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 引入项目财务样式

    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 50px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 40px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #666;
      font-weight: 700;
      // padding-right: 100px;
      padding-right: 60px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #409eff !important;
    }
    /deep/.el-tabs__item:hover {
      color: #409eff !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }

  // dialog弹窗
  // 修改弹窗引入别的
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 45px;
      padding: 0;
      font-size: 18px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 10px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }
  // img dia 尾部
  .imgFooter {
    padding-left: 0;
    justify-content: center;
    margin-bottom: 20px;
  }

  /deep/.el-form-item {
    margin-bottom: 15px;
  }
  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    font-weight: 700;
    box-sizing: border-box;
    padding-right: 40px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    // display: flex;
    /deep/.el-select {
      width: 100%;
      // 修改多选标签大小

      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: 18px;
      }
    }
    .el-input__inner {
      // font-size: 14px;
      font-size: inherit;
      width: 100%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 100%;
      .el-textarea__inner {
        height: 70px;
        // font-size: 14px;
        min-height: 70px !important;
        font-size: inherit;
        resize: none;
        border-radius: 0;
        font-family: Microsoft YaHei;
      }
    }
    .el-radio-group {
      height: 35px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      .el-radio {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // margin-right: 15%;
        width: 25%;
      }
      .el-radio__input {
        width: 16px;
        height: 16px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        font-size: 14px;
        padding-left: 5px;
      }
    }
  }
  .diaForm_box {
    width: 100%;
    padding-left: 50px;
    box-sizing: border-box;
    /deep/.labelFormItem {
      /deep/.ProjectType {
        width: 80%;
        flex-wrap: wrap;
        height: initial;
        max-height: 105px;
        overflow-y: auto;
        /deep/.el-radio {
          // width: 30%;
          height: 35px;
        }
        /deep/.el-checkbox {
          width: 20%;
          .el-checkbox__label {
            font-size: 16px;
            font-weight: normal;
          }
        }
      }
      /deep/.el-form-item__label {
        line-height: 36px;
      }
    }
    .inputTwoRow {
      box-sizing: border-box;
      // padding: 0 16%;
      // padding-right: 14%;
      width: 100%;
      display: flex;
      /deep/.el-form-item:nth-child(2) {
        margin-left: 10%;
      }
      /deep/.el-input__inner {
        width: 100%;
      }
    }
    .diaFormTitle {
      width: 100%;
      font-weight: bold;
      color: #128bf1;
      font-size: 18px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .diaFormTitle::before {
      content: '';
      display: block;
      width: 3px;
      height: 16px;
      background-color: #40a0f2;
      margin-right: 5px;
    }
    .diaFormTitle1 {
      width: 100%;
      font-weight: bold;
      color: #128bf1;
      font-size: 18px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }
    .diaFormTitle1 span {
      display: flex;
      align-items: center;
    }
    .diaFormTitle1 span::before {
      content: '';
      display: block;
      width: 3px;
      height: 16px;
      background-color: #40a0f2;
      margin-right: 5px;
    }
  }
  .diaEditFormBox {
    .el-form-item {
      margin-bottom: 8px;
    }
    /deep/.el-form-item__label {
      line-height: 30px;
    }
    /deep/.el-form-item__content {
      line-height: 30px;
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  // 修改弹窗引入别的
  .shenpiBtn {
    display: flex;
    justify-content: flex-end;
    padding-right: 100px;
    box-sizing: border-box;
    /deep/.el-button {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 130px;
      height: 45px;
      border-radius: 24px;
      font-size: 18px;
      font-weight: 400;
      background-color: #40a0f2;
      margin-left: 40px;
      color: #fff;
      border: none;
    }
  }

  // **修改自动计算的价钱的disable÷
  /deep/.computedDisable .is-disabled .el-input__inner {
    background-color: #fff;
  }
  // **修改自动计算的价钱的disable÷
}

// 修改弹窗样式
.addClientDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 5vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
    .el-dialog__footer {
      padding-bottom: 10px;
    }
  }
}
.addOtherDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
    .el-dialog__footer {
      padding-bottom: 10px;
    }
  }
}
.stepDia {
  /deep/.el-dialog {
    min-width: 750px;
    margin-top: 10vh !important;
    margin-bottom: 0;
    .el-dialog__body {
      padding: 20px 20px;
      padding-bottom: 10px;
    }
  }
}
.upload-demo {
  display: flex;
  align-items: flex-end;
  /deep/.el-button {
    padding: 0;
    border: none;
    background-color: #fff;
    color: #128bf1;
    font-size: 16px;
    font-weight: normal;
    img {
      width: 19px;
      height: 14px;
    }
  }
}
/deep/.el-upload-list__item-name {
  display: none;
}
// 上传图片组件
.upLoadImgList > div {
  display: flex;
  flex-wrap: wrap;
}
.upLoadImgList {
  display: flex;
  flex-wrap: wrap;
  .upLoadImgBox {
    width: 100px;
    height: 85px;
    margin-right: 15px;
    margin-bottom: 15px;
    .closeBox {
      width: 100%;
      height: 100%;
      position: relative;
      .closeIcon {
        display: none;
        cursor: pointer;
        font-size: 20px;
        color: #128bf1;
        position: absolute;
        right: -5px;
        top: -5px;
      }
    }
    /deep/.closeBox:hover .closeIcon {
      display: block !important;
    }

    /deep/.el-avatar--square {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .upLoadImgBox {
    width: 100px;
    height: 85px;
    margin-right: 15px;
    margin-bottom: 15px;
    .closeBox {
      width: 100%;
      height: 100%;
      position: relative;
      .closeIcon {
        display: none;
        cursor: pointer;
        font-size: 20px;
        color: #128bf1;
        position: absolute;
        right: -5px;
        top: -5px;
      }
    }
    /deep/.closeBox:hover .closeIcon {
      display: block !important;
    }

    /deep/.el-avatar--square {
      width: 100% !important;
      height: 100% !important;
      border-radius: 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .addUpLoadBtn {
    height: 85px;
    display: flex;
    align-items: flex-end;
    .upload-demo {
      height: 25px;
      align-items: center;
    }
  }
}
.ShowFormBtn {
  width: 100%;
  box-sizing: border-box;
  padding-right: 50px;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
  /deep/.el-button {
    font-size: 18px;
    font-weight: normal;
    border: none;
    width: 130px;
    height: 45px;
    background: #f4a029;
    color: #fff;
    border-radius: 24px;
    padding: 0;
    margin-left: 30px;
  }
}

.imgDetails {
  height: 70vh;
  width: 100%;
  overflow: scroll;
  display: flex;
  justify-content: center;
}

// 禁用表单样式
/deep/.el-input.is-disabled .el-input__inner {
  color: #999;
  background-color: #f2f5f9;
}
/deep/.el-radio__input.is-disabled + span.el-radio__label {
  color: #999;
}
// 禁用textarea
/deep/.el-textarea.is-disabled .el-textarea__inner {
  color: #999;
  background-color: #f2f5f9;
}
.yauto {
  height: calc(80vh - 70px);
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

.table__body::-webkit-scrollbar {
  width: 5px !important;
}
.table__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.table__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
.imgDetails {
  height: 70vh;
  width: 100%;
  overflow: scroll;
  display: flex;
  justify-content: center;
}
.imgDetails::-webkit-scrollbar {
  width: 10px !important;
  height: 10px !important;
}
.imgDetails::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(50, 49, 89, 0.2);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 40%;
  .filter-dash-btn {
    border: none;
    border-radius: 24px;
    background-color: #f4f5f6;
    height: 45px;
    color: #333;
    font-size: 16px;
    .filter-tips-default {
      color: #333;
    }
  }
  .checked-app-item {
    margin-left: 10px;
    border: none;
    background-color: #f4f5f6;
  }
}
/deep/.el-upload-dragger {
  box-sizing: border-box;
  padding: 0 20px;
  width: inherit;
  height: 40px;
}

// 修改禁用textArea样式
/deep/.onlyShowText {
  .el-textarea__inner {
    border: none !important;
    box-sizing: border-box !important;
    background-color: #fff !important;
    padding: 0 !important;
    padding-top: 5px !important;
    // color: #333 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 16px !important;
  }
}
// 修改选择项目的尺寸过长展示不全
/deep/.el-select__tags > span {
  width: 100%;
  .el-tag {
    height: auto;
    max-width: 100% !important;
    white-space: pre-wrap;
    .el-select__tags-text {
      max-width: 100%;
      white-space: pre-wrap;
    }
  }
}
/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;

    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
</style>